import { render, staticRenderFns } from "./LeaveType.vue?vue&type=template&id=5de645b0&scoped=true"
import script from "./LeaveType.vue?vue&type=script&lang=js"
export * from "./LeaveType.vue?vue&type=script&lang=js"
import style0 from "./LeaveType.vue?vue&type=style&index=0&id=5de645b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de645b0",
  null
  
)

export default component.exports